// src/store/slices/aaSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appId: null,
  leadId: null,
  internalLeadId: null,
  responseId: null,
  OpportunityId: null,
  aaUrl: null,
  OpportunityName: null,
  userData: {},
  kfsUrl: null,
  amountReq: null,
  selectedOffer: {},
  fatakPayOffer: [],
  fatakPayDataReq: {},
  eMendateUrl: null,
  IframeUrl:null
};

export const aaSlice = createSlice({
  name: "aa",
  initialState,
  reducers: {
    setAppId: (state, action) => {
      state.appId = action.payload;
    },
    setLeadId: (state, action) => {
      state.leadId = action.payload;
    },
    setResponse: (state, action) => {
      state.responseId = action.payload;
    },
    setInternalLead: (state, action) => {
      state.internalLeadId = action.payload;
    },
    setOpportunityId: (state, action) => {
      state.OpportunityId = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setFatakPayOffer: (state, action) => {
      state.fatakPayOffer = action.payload;
    },
    setFatakPayData: (state, action) => {
      state.fatakPayDataReq = action.payload;
    },
    setSelectedOffer: (state, action) => {
      state.selectedOffer = action.payload;
    },

    setOpportunityName: (state, action) => {
      state.OpportunityName = action.payload;
    },
    setAmountRequired: (state, action) => {
      state.amountReq = action.payload;
    },

    setAAurl: (state, action) => {
      state.aaUrl = action.payload;
    },
    setIframeUrl: (state, action) => {
      state.IframeUrl = action.payload;
    },
    setKycurl: (state, action) => {
      state.kycUrl = action.payload;
    },
    setEmendateUrl: (state, action) => {
      state.eMendateUrl = action.payload;
    },
    setKfsUrl: (state, action) => {
      state.kfsUrl = action.payload;
    },

    clearAAData: (state) => {
      state.appId = null;
      state.leadId = null;
      state.responseId = null;
    },
  },
});

export const {
  setAppId,
  setLeadId,
  setResponse,
  clearAAData,
  setOpportunityId,
  setInternalLead,
  setSelectedOffer,
  setUserData,
  setAAurl,
  setFatakPayData,
  setFatakPayOffer,
  setAmountRequired,
  setOpportunityName,
  setKycurl,
  setEmendateUrl,
  setKfsUrl,
 setIframeUrl
} = aaSlice.actions;
export default aaSlice.reducer;
